import { render, staticRenderFns } from "./attr.vue?vue&type=template&id=ff6cee2c&scoped=true&"
import script from "./attr.vue?vue&type=script&lang=js&"
export * from "./attr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6cee2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff6cee2c')) {
      api.createRecord('ff6cee2c', component.options)
    } else {
      api.reload('ff6cee2c', component.options)
    }
    module.hot.accept("./attr.vue?vue&type=template&id=ff6cee2c&scoped=true&", function () {
      api.rerender('ff6cee2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/goods/goodsList/attr.vue"
export default component.exports